import Link from 'next/link'

import Layout from 'shared/layout'
import { Divider, FlexCol, SectionContainer } from 'styles/styled'
import * as Styles from './style'
import * as dataSource from './data'

const PrivacyPolicy = () => {
  return (
    <Layout>
      <SectionContainer className='privacy'>
        <FlexCol gap='16px'>
          <Styles.Heading>Privacy policy</Styles.Heading>
          <Styles.Info>Effective June 23, 2023</Styles.Info>
        </FlexCol>

        <Divider margin='56px 0' />

        <FlexCol gap='56px'>
          <FlexCol gap='16px'>
            <Styles.SubHeading>
              Protecting your privacy and maintaining your trust is important to
              us.
            </Styles.SubHeading>

            <FlexCol gap='16px'>
              <Styles.Info>
                This Privacy Policy covers the privacy practices of VTR Services
                Limited Liability Company, LLC and any additional subsidiary,
                affiliate, or branch that we have or may subsequently form
                (collectively <span>“VTR Connect”</span>, <span>“we”</span>, or{' '}
                <span>“us”</span>).
              </Styles.Info>
              <Styles.Info>
                Our Privacy Policy is meant to help you understand how we
                collect, use, and share your personal information, and to assist
                you in exercising privacy rights available to you by law.
              </Styles.Info>
            </FlexCol>
          </FlexCol>
          {/* #region  1. */}
          <FlexCol gap='16px'>
            <Styles.SubHeading>1. SCOPE AND EFFECTIVE DATE</Styles.SubHeading>

            <FlexCol gap='16px'>
              <Styles.Info>
                This Privacy Policy applies to personal information handled or
                otherwise processed by us in our business, including on our
                websites, mobile applications, and other online or offline
                offerings provided by VTR Connect (collectively, the{' '}
                <span>“Services“</span>), and applies to you whether you are
                accessing the Services for personal purposes or for business
                purposes and whether you are an owner, property manager, tenant,
                or service provider with respect to any real estate properties,
                or if you are using our Services or visiting our website(s).
              </Styles.Info>
              <Styles.Info>
                Notwithstanding the above, this Privacy Policy does not apply to
                any third-party websites, services, any public or decentralized
                blockchain, or applications even if they are accessible through
                our Services.
              </Styles.Info>
              <Styles.Info>
                This Privacy Policy is effective upon the above listed Effective
                Date. By continuing to use our Services, you are agreeing to
                this Privacy Policy.
              </Styles.Info>
            </FlexCol>
          </FlexCol>
        </FlexCol>

        <Divider margin='56px 0' />
        {/* #region  2. */}
        <FlexCol gap='16px'>
          <Styles.SubHeading>
            2. PERSONAL INFORMATION WE COLLECT
          </Styles.SubHeading>

          <FlexCol gap='24px'>
            <Styles.Info>
              The information we collect from you depends on the type of account
              you set up with us, or the Services you use. We may collect the
              following types of information:
            </Styles.Info>

            <Styles.ListContainer>
              <ul>
                {dataSource.dataCollection?.map((data, index) => (
                  <li key={index} className='last-point'>
                    {data?.title ? <span>{data?.title}. </span> : null}
                    <Styles.Info>{data?.description}</Styles.Info>
                  </li>
                ))}
              </ul>

              <Styles.Info>
                In addition to the information that you affirmatively provide
                us, we may also automatically collect personal information when
                you use our services such as:
              </Styles.Info>

              <ul>
                {dataSource.autoDataCollection?.map((data, index) => (
                  <li key={index}>
                    {data?.title ? <span>{data?.title}. </span> : null}
                    <Styles.Info>{data?.description}</Styles.Info>

                    <ul>
                      {data?.info?.map((info, index) => (
                        <li key={index}>
                          {info?.title ? <span>{info?.title}. </span> : null}
                          <Styles.Info>{info?.description}</Styles.Info>
                        </li>
                      ))}
                    </ul>
                  </li>
                ))}
              </ul>
            </Styles.ListContainer>
          </FlexCol>
        </FlexCol>

        <Divider margin='56px 0' />

        {/* #region  3. */}
        <FlexCol gap='16px'>
          <Styles.SubHeading>3. HOW WE USE YOUR INFORMATION</Styles.SubHeading>

          <Styles.Info>
            We use your information for a variety of business purposes,
            including to provide our Services, for administrative purposes, and
            to market products and services that may be of interest to you,
            whether from VTR Connect or nonaffiliated third parties, as
            described below.
          </Styles.Info>
        </FlexCol>
        <FlexCol gap='16px' margin='24px 0 0 0'>
          <Styles.SubHeading>Provide our Services</Styles.SubHeading>

          <FlexCol gap='24px'>
            <Styles.Info>
              We use your information to fulfill our contract with you and
              provide you with our Services, such as:
            </Styles.Info>

            <Styles.ListContainer isCenter>
              <ul>
                {dataSource.servicesData?.map((data, index) => (
                  <li key={index}>
                    <Styles.Info>{data}</Styles.Info>
                  </li>
                ))}
              </ul>
            </Styles.ListContainer>
          </FlexCol>
        </FlexCol>

        <FlexCol gap='16px' margin='24px 0 0 0'>
          <Styles.SubHeading>Administrative Purposes</Styles.SubHeading>

          <FlexCol gap='24px'>
            <Styles.Info>
              We use your information for various administrative purposes, such
              as:
            </Styles.Info>

            <Styles.ListContainer isCenter>
              <ul>
                {dataSource.adminPurposeData?.map((adminData, index) => (
                  <li key={index}>
                    <Styles.Info>{adminData}</Styles.Info>
                  </li>
                ))}
              </ul>
            </Styles.ListContainer>
          </FlexCol>
        </FlexCol>
        <FlexCol gap='16px' margin='24px 0 0 0'>
          <Styles.SubHeading>Other purposes</Styles.SubHeading>

          <FlexCol gap='24px'>
            <Styles.Info>
              We also use your information for other purposes as requested by
              you or as permitted by applicable law.
            </Styles.Info>

            <Styles.ListContainer isCenter>
              <ul>
                {dataSource.otherPurposeData?.map((info, index) => (
                  <li key={index}>
                    {info?.title ? <span>{info?.title}. </span> : null}
                    <Styles.Info>{info?.description}</Styles.Info>
                  </li>
                ))}
              </ul>
            </Styles.ListContainer>
          </FlexCol>
        </FlexCol>

        <Divider margin='56px 0' />
        {/* #region  4. */}
        <FlexCol gap='16px' margin='24px 0 0 0'>
          <Styles.SubHeading>
            4. DISCLOSING YOUR INFORMATION TO THIRD PARTIES
          </Styles.SubHeading>

          <FlexCol gap='24px'>
            <Styles.Info>
              In addition to our internal use of information as described above,
              we may disclose your information to third parties for a variety of
              business purposes such as:
            </Styles.Info>

            <Styles.ListContainer isCenter>
              <ul>
                {dataSource.discloseData?.map((info, index) => (
                  <li key={index}>
                    {info?.title ? <span>{info?.title}. </span> : null}
                    <Styles.Info>{info?.description}</Styles.Info>
                  </li>
                ))}
              </ul>
            </Styles.ListContainer>
          </FlexCol>
        </FlexCol>

        <Divider margin='56px 0' />

        <FlexCol gap='16px' margin='24px 0 0 0'>
          <Styles.SubHeading>
            5. YOUR PRIVACY CHOICES AND RIGHTS
          </Styles.SubHeading>

          <FlexCol gap='24px'>
            <Styles.Info>
              We provide you with the following privacy choices regarding your
              personal information as required by applicable law and which are
              described below.
            </Styles.Info>

            <Styles.ListContainer isCenter>
              <ul>
                {dataSource.privacyChoices?.map((info, index) => (
                  <li key={index}>
                    {info?.title ? <span>{info?.title}. </span> : null}
                    <Styles.Info>{info?.description}</Styles.Info>
                  </li>
                ))}
              </ul>
            </Styles.ListContainer>

            <FlexCol margin='24px 0'>
              <Styles.Info>
                To the extent required by applicable law, you may have the right
                to:
              </Styles.Info>
            </FlexCol>
            <Styles.ListContainer isCenter>
              <ul>
                {dataSource.rightsData?.map((info, index) => (
                  <li key={index}>
                    <span>{info?.title}</span>
                    <Styles.Info>{info?.description}</Styles.Info>
                  </li>
                ))}
              </ul>
            </Styles.ListContainer>

            <FlexCol margin='24px 0 0 0'>
              <Styles.Info>
                If you would like to exercise any of these rights, please
                contact us as set forth in “Contact Us” below. We will process
                such requests in accordance with applicable laws. To protect
                your privacy, we will take steps to verify your identity before
                fulfilling your request.
              </Styles.Info>
            </FlexCol>
          </FlexCol>
        </FlexCol>

        <Divider margin='56px 0' />

        <FlexCol gap='16px'>
          <Styles.SubHeading>6. INTERNATIONAL DATA TRANSFERS</Styles.SubHeading>

          <FlexCol gap='16px'>
            <Styles.Info>
              You acknowledge that all information processed by us may be
              transferred, processed, and stored anywhere in the world,
              including but not limited to, the United States or other
              countries, which may have data protection laws that are different
              from the laws where you live. We endeavor to safeguard your
              information consistent with the requirements of applicable laws.
            </Styles.Info>
            <Styles.Info>
              If we transfer personal information to countries outside the
              European Economic Area, United Kingdom, or Switzerland, we will
              put in place appropriate safeguards as required by applicable law
              to ensure that this transfer complies with the applicable laws and
              regulations and require our third-party service providers and
              partners to have appropriate safeguards as well. Further details
              can be provided upon request, please contact us as set forth in
              “Contact Us” below.
            </Styles.Info>
          </FlexCol>
        </FlexCol>

        <Divider margin='56px 0' />

        <FlexCol gap='16px'>
          <Styles.SubHeading>7. DATA RETENTION</Styles.SubHeading>

          <Styles.Info>
            We store the personal information we collect as described in this
            Privacy Policy for as long as you use our Services or as necessary
            to fulfill the purpose(s) for which it was collected, provide our
            Services, resolve disputes, establish legal defenses, conduct
            audits, pursue legitimate business purposes, enforce our agreements,
            and comply with applicable laws.
          </Styles.Info>
        </FlexCol>

        <Divider margin='56px 0' />

        <FlexCol gap='16px'>
          <Styles.SubHeading>8. SECURITY OF YOUR INFORMATION</Styles.SubHeading>

          <Styles.Info>
            We take steps to ensure that your information is treated securely
            and in accordance with this Privacy Policy. Unfortunately, no system
            is 100% secure, and we cannot ensure or warrant the security of any
            information you provide to us. We have taken appropriate safeguards
            to require that your personal information will remain protected and
            require our third-party service providers and partners to have
            appropriate safeguards as well. To the fullest extent permitted by
            applicable law, we do not accept liability for unintentional
            disclosure.
          </Styles.Info>
          <Styles.Info>
            By using the Services or providing personal information to us, you
            agree that we may communicate with you electronically regarding
            security, privacy, and administrative issues relating to your use of
            the Services. If we learn of a security system`s breach, we may
            attempt to notify you electronically by posting a notice on the
            Services, by mail, or by sending an e-mail to you.
          </Styles.Info>
        </FlexCol>

        <Divider margin='56px 0' />

        <FlexCol gap='16px'>
          <Styles.SubHeading>9. CALIFORNIA RESIDENTS</Styles.SubHeading>

          <Styles.Info>
            The California Consumer Privacy Act of 2018 (“<span>CCPA</span>”),
            as amended by the California Privacy Rights Act (“<span>CPRA</span>
            “), applies solely to individuals, who are residents of the State of
            California. The CCPA provides consumers (California residents) with
            specific rights regarding their personal information. Only you, or
            someone legally authorized to act on your behalf, may make a
            verifiable consumer request related to your Personal Information.
            When you make a request, we will ask you to provide sufficient
            information that allows us to reasonably verify you are the person
            about whom we collected personal information or an authorized
            representative, which may include asking you to answer questions
            regarding your account and use of our Services.
          </Styles.Info>
          <Styles.Info>
            To make a request related to your personal information rights under
            the CCPA, please contact us at the address in the “Contact Us”
            section below.
          </Styles.Info>
        </FlexCol>

        <Divider margin='56px 0' />

        <FlexCol gap='16px'>
          <Styles.SubHeading>10. CHILDREN</Styles.SubHeading>

          <Styles.Info>
            The Services are not directed to children under 18 (or other age as
            required by local law), and we do not permit users under age 18 or
            knowingly collect personal information from children under age 18.
            If you learn that your child has provided us with personal
            information without your consent, you may contact us as set forth in
            “Contact Us” below. If we learn that we have collected any personal
            information in violation of applicable law, we will promptly take
            steps to delete such information and terminate the child`s account.
          </Styles.Info>
        </FlexCol>

        <Divider margin='56px 0' />

        <FlexCol gap='16px'>
          <Styles.SubHeading>11. CONTACT US</Styles.SubHeading>

          <Styles.Info>
            If you have any questions about our privacy practices or this
            Privacy Policy, or if you wish to submit a request to exercise your
            rights as detailed in this Privacy Policy, please contact us.
          </Styles.Info>
          <Styles.Info>
            VTR Connect
            <br />{' '}
            <Link href={'mailto:VTRSUPPORT@VTRCONNECT.COM'}>
              <span>VTRSUPPORT@VTRCONNECT.COM</span>
            </Link>
          </Styles.Info>
        </FlexCol>
      </SectionContainer>
    </Layout>
  )
}

export default PrivacyPolicy
